import { NetworkService } from './services/network.service';
import { Component } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NavController, Platform } from '@ionic/angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Agenda',
      url: '/agenda',
      icon: 'calendar'
    },
    {
      title: 'Emergencia',
      url: '/agendar-sin-cita',
      icon: 'alert'
    },
    {
      title: 'Expedientes',
      url: '/buscador-citas',
      icon: 'folder-open'
    },
    {
      title: 'Bloqueo Agenda',
      url: '/bloqueo-citas',
      icon: 'close-circle-outline'
    },
    {
      title: 'Pre-Consultas',
      url: '/pre-consulta',
      icon: 'list'
    }
    // ,
    // {
    //   title: 'Pre-Consultas',
    //   url: '/pre-consulta',
    //   icon: 'list'
    // }
  ];
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private navController: NavController,
    private networkService: NetworkService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener('backbutton', (event) => {
          event.preventDefault();
          event.stopPropagation();
          console.log('Se presiono back');
        }, false);
      });
      setTimeout(() => {
        this.networkService.checkConnectionBehaviour();
      }, 2000);
      this.splashScreen.hide();
    });
  }
  salir() {
    localStorage.removeItem('logged');
    this.navController.navigateRoot(['/login']);
  }

}
